export const AppConfig = {
  site_name: 'timeghost.io',
  title: 'timeghost.io',
  description: 'timeghost.io',
  locale: 'en',
};
